module.exports = __webpack_public_path__ + "static/media/404-hero.28a6e19a.png";